import { RootState } from "../../../store";
import { ResourceType } from "../../../../services/cloudchipr.api";
import { getFirstParentInHierarchyResourceType } from "../../../../utils/helpers/resources/getFirstParentInHierarchyResourceType";
import { resourceTypeDataSelector } from "../../../account/selectors/resource-type-data/resourceTypeDataSelector";

export const liveFilteredResourcesEmsPriceSelector = (
  state: RootState,
  resourceType: ResourceType,
): number | null => {
  const data = resourceTypeDataSelector(
    state,
    getFirstParentInHierarchyResourceType(resourceType) ?? resourceType,
  );

  return data?.estimated_monthly_waste ?? null;
};
